import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { GovernanceProvider } from './contexts/GovernanceContext';
import HomePage from './components/HomePage';
import GovernancePage from './components/GovernancePage';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <GovernanceProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/governance" element={<GovernancePage />} />
              </Routes>
            </div>
          </Router>
        </GovernanceProvider>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;